import AddonVariant from "src/api/graphql/__generated__/enums/AddonVariant";
import Addon, { AddonProps } from "src/components/Addon/Addon";
import AddonWrapper from "src/components/Addon/AddonWrapper";
import { useModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";

const GatheringPublicFullHeaderAddon = ({
	addonId,
	variant = AddonVariant.Link,
	label,
	url,
	...props
}: {
	addonId?: string;
	url?: string;
} & AddonProps) => {
	const { presentModal } = useModal<GatheringModal>();

	const onPressNoUrl = () => {
		if (url) {
			presentModal("GatheringAddonCopyModal", {
				props: {
					variant,
					text: url,
				},
			});
		}
	};

	const addon = <Addon label={label} variant={variant} {...props} />;
	return (
		<AddonWrapper
			testID="GatheringPublicFullHeaderAddon"
			url={url}
			label={label}
			variant={variant}
			onPressNoUrl={onPressNoUrl}
		>
			{addon}
		</AddonWrapper>
	);
};

export default GatheringPublicFullHeaderAddon;
